import { createContext } from 'react';

import { TPrototypeReviewDto } from '@app-velocity/av-api-v2';

export type ReviewContextType = {
  review: TPrototypeReviewDto;
};

export const ReviewContext = createContext<ReviewContextType>({
  review: {} as TPrototypeReviewDto,
});
